<template>
  <main class="public-shell">
    <section class="public-card">
      <img class="public-logo" src="@/assets/logo.svg" alt="Orator Pro" />
      <p class="eyebrow">Name pronunciation</p>
      <h1>Find your review link</h1>
      <p class="copy">
        Enter the email address your university used for graduation. If we recognise it, we will send your secure review link.
      </p>

      <form v-if="!sent" class="form" @submit.prevent="submit">
        <label class="field-label" for="student-email">Email address</label>
        <input
          id="student-email"
          v-model.trim="email"
          class="field-input"
          type="email"
          autocomplete="email"
          required
        />
        <button class="primary-button" type="submit" :disabled="loading">
          {{ loading ? "Sending..." : "Send review link" }}
        </button>
      </form>

      <div v-else class="done-panel">
        <h2>Check your inbox</h2>
        <p>If we recognise that email address, your review link is on its way.</p>
      </div>

      <p v-if="error" class="error-copy">{{ error }}</p>
    </section>
  </main>
</template>

<script>
import { requestStudentMagicLink } from "@/lib/api";

export default {
  name: "PublicReviewRequest",
  data() {
    return {
      email: "",
      loading: false,
      sent: false,
      error: "",
    };
  },
  computed: {
    eventId() {
      return this.$route.params.eventId;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      this.error = "";
      try {
        await requestStudentMagicLink(this.eventId, this.email);
        this.sent = true;
      } catch (error) {
        this.error = "Unable to send a review link right now.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.public-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1.5rem;
  background: var(--orator-light);
}

.public-card {
  width: min(100%, 480px);
  background: white;
  border: 1px solid var(--orator-smoke);
  border-radius: 0.75rem;
  box-shadow: var(--orator-shadow);
  padding: 2rem;
}

.public-logo {
  width: 170px;
  margin-bottom: 2rem;
}

.eyebrow {
  margin: 0 0 0.5rem;
  color: var(--orator-blue);
  font-weight: 800;
  text-transform: uppercase;
  font-size: 0.75rem;
}

h1 {
  margin: 0;
  color: var(--orator-navy);
  font-size: 2rem;
  line-height: 1.1;
}

h2 {
  margin: 0 0 0.5rem;
  color: var(--orator-navy);
}

.copy,
.done-panel p {
  color: var(--orator-graphite);
  line-height: 1.55;
}

.form {
  display: grid;
  gap: 0.85rem;
  margin-top: 1.5rem;
}

.field-label {
  color: var(--orator-arsenic);
  font-weight: 800;
  font-size: 0.85rem;
}

.field-input {
  border: 1px solid var(--orator-steel);
  border-radius: 0.5rem;
  padding: 0.8rem;
  font: inherit;
}

.primary-button {
  border: 0;
  border-radius: 0.5rem;
  background: var(--orator-blue);
  color: white;
  padding: 0.85rem 1rem;
  font-weight: 800;
}

.primary-button:disabled {
  opacity: 0.65;
}

.done-panel {
  margin-top: 1.5rem;
  background: var(--orator-cloud);
  border-radius: 0.5rem;
  padding: 1rem;
}

.error-copy {
  margin-top: 1rem;
  color: #b42318;
  font-weight: 700;
}
</style>
